import { BaseService } from '../../../infra/base.service'
import type { Review } from './review'
import type { ReviewsRepository } from './reviews.repository'

export class ReviewsService extends BaseService<Review> {
    constructor(private rep: ReviewsRepository) {
        super(rep)
    }

    async notes() {
        return await this.rep.notes()
    }

    async setStatus(reviewId: string, status: number) {
        return await this.rep.setStatus(reviewId, status)
    }

    async setSentToGoogle(reviewId: string) {
        return await this.rep.setSentToGoogle(reviewId)
    }
}
